module.exports = {"gameWidth":360,"gameHeight":518,"defaultVolume":0.6,"defaultCurrency":"EUR","defaultLanguage":"en","hideLoaderDelay":200}


//////////////////
// WEBPACK FOOTER
// ./config/config.yaml
// module id = 26
// module chunks = d-game